// HHT2 Intonation 영상 video id
const IntonationVideoIdMap = {
  "hht2": {
      "01": "75ce6e80af1f51f600c5b852a03531b0",
      "02": "6e21228771f850a3e6d4ccdd7020afbf",
      "03": "b15c858dab064b4baf4636a3ac464306",
      "04": "7d631aa1ae38e4fd4791f2e9ac4beca3",
      "05": "78de91ac24d7dfa1894737877e92055a",
      "06": "029b3017072acfa88163acb5117e1541",
      "07": "fbfdba42d2ae637017c8ea6c8d7e97e8",
      "08": "c23a67147ae6c87e94c2aaae3798bda4",
      "09": "cf709029cbb4e70457d6df05de4e383c",
      "10": "91150baf0fc86dfd1fdb93f5adbbf3d7",
      "11": "2889fb87e2691305b479d1484eaa20e3",
      "12": "25b2155ebe0162e11e40da9e4af5e311",
      "13": "e46f610d2a22b63d73d9264a886a149d",
      "14": "c5583d6fcb52da9504fe045313400c8b",
      "15": "4b86d92b8429bc540f252d6dd2b35b2e",
      "16": "46ac1f9bc3ef3373da0178a6ae25b1af",
      "17": "1feb2d5c04f836b26dd692134ac476bd",
      "18": "cf406d084870ec0a50980afdb7f42b77",
      "19": "8e12c4fd96d2d352502bae361a7a68ae",
      "20": "7788f2630064eeb06f56427befb8174a"
}}

export default IntonationVideoIdMap;